'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleManager = undefined;
exports.createStyleManager = createStyleManager;

var _styleManager = require('jss-theme-reactor/styleManager');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StyleManager = exports.StyleManager = function () {
  function StyleManager() {
    _classCallCheck(this, StyleManager);
  }

  return StyleManager;
}();

function createStyleManager() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var styleManager = (0, _styleManager.createStyleManager)(options);
  Object.setPrototypeOf(styleManager, new StyleManager());
  return styleManager;
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/styles/manager.js
// module id = 560
// module chunks = 32